<template>
    <div>
        <el-container>
            <count-down :remainTime="countTimeSecond" @countDownEnd="countDownEndHandler"></count-down>
            <el-header>
                <div class="msg_cn" id="infodata">
                    {{ infodata }}
                </div>
            </el-header>
            <el-main>
                <img  src="@/assets/images/warn.png" style="max-width:35rem;max-height: 80%;" />
            </el-main>        
        </el-container>
        <homeBtn @goHome="goBack" ref="homeBtn"></homeBtn>
        <backBtn @goBack="goBack" ref="backBtn"></backBtn>
    </div>
</template>

<script>
    import homeBtn from '@/components/homeButton'
    import backBtn from '@/components/backButton'
    export default {
        name: "warnPage",
        components: {
            homeBtn,
            backBtn
        },
        data() {
            return {
                baseUrl: this.myStore.state.mainUrl,
                goBackUrl:this.myStore.state.mainUrl+'/waiting',
                infodata:'',
                countTimeSecond: 60,
                //打开超时提示框
                timeoutDialogVisible: false
            }
        },
        created () {
            let warnMsg = this.$route.params.warnMsg;
            if(typeof(warnMsg) !== 'undefined') {
                this.infodata = warnMsg;
            }
        },
        mounted () {
            
        },
        destroyed () {
            
        },
        methods: {
            async goBack() {
                this.$router.push({ path: this.goBackUrl })
            },
            async countDownEndHandler(time) {
                if(time === 0) {
                    this.timeoutDialogVisible = true;
                    this.$refs.operationTimeout.openDialog();
                } 
            },
            timeoutEndHandler() {
                this.timeoutDialogVisible = false;
                this.goBack();
            }
        }
    }
</script>

<style scoped>

</style>